module.exports = __webpack_public_path__ + "static/media/26.57217e34.jpg";